import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';
import type { ReferentHandicap } from './useParametrage';

/**
 * Référent handicap de l'organisme (TF-341), affiché sur l'écran
 * « Accessibilité » ; `null` tant que la direction n'en a pas réglé.
 */
export function useReferentHandicap() {
  return useQuery({
    queryKey: ['accessibilite'],
    queryFn: () => appelApi<{ referent: ReferentHandicap | null }>('/accessibilite'),
    staleTime: 60_000,
  });
}
